/**
 * Adicina campos ao fildset default do schema base.
 *
 * baseSchema: é a função que retorna o schema base
 * schemaProps: são as propriedade passadas ao chamar baseSchema.
 * fields: array de campos a serem adicionados no fildset default.
 * properties: objeto contendo as definições dos campos.
 * required: array de campos obrigatórios.
 */
export const extendSchema = (
  baseSchema,
  schemaProps,
  fields,
  properties,
  required = [],
) => {
  const newSchema = baseSchema(schemaProps);
  return {
    ...newSchema,
    fieldsets: newSchema.fieldsets.map((fieldset) =>
      fieldset['id'] === 'default'
        ? { ...fieldset, fields: fields.concat(fieldset.fields) }
        : fieldset,
    ),
    properties: { ...newSchema.properties, ...properties },
    required: [...newSchema.required, ...required],
  };
};
